import { GetterTree } from "vuex"
import { RootState } from "./types/state"
// import md5 from 'js-md5'
import { OrderStatus } from "@/types/enum/OrderEnum"
const getters: GetterTree<RootState, any> = {
  keyword: (state: RootState) => state.keyword,
  tokenExpireTime: (state: RootState) => state.tokenExpireTime,
  isPc: (state: RootState) => state.isPc,
  merchIds: (state: RootState) => state.merchIds,
  tabIndex: (state: RootState) => state.tabIndex,
  orderTotal: (state: RootState) => state.orderTotal,

  orderStatusCount: (state: RootState) => state.orderStatusCount,

  showNewOrderModal: (state: RootState) => state.showNewOrderModal,

  incomingOrderCount: (state: RootState) => {
    let incoming = state.orderStatusCount.find((x) => {
      return x.text === "Incoming"
    }) as {
      mappingFiled: string
      text: string
      count: number
    }
    return incoming.count || 0
  },

  refundingOrderCount: (state: RootState) => {
    return state.refundOrderList.length
  },

  showCombinedTab: (state: RootState) => state.showCombinedTab,

  makeAlias(state: RootState) {
    let merchId = state.merchId.toLocaleUpperCase().replace(/-/g, ""),
      userId = state.userInfo.userId.toLocaleUpperCase().replace(/-/g, "")
    // return md5(``).toLocaleUpperCase()
    return `${merchId}:${userId}`
  },

  merchant: (state: RootState) => state.loginMerchant,

  options: (state: RootState) => state.options,

  userInfo: (state: RootState) => state.userInfo,

  merchId: (state: RootState) => state.merchId,

  headerTitle: (state: RootState) => state.headerTitle,

  orderList: (state: RootState) => state.orderList,

  refundOrderList: (state: RootState) => state.refundOrderList,

  showLoading: (state: RootState) => state.showLoading,

  showSelectMerchantModal: (state: RootState) => state.showSelectMerchantModal,

  unreadMessageCount: (state: RootState) => state.unreadMessageCount,

  newMessage: (state: RootState) => state.newMessage,

  signalRConnected: (state: RootState) => state.signalRConnected,

  initializingSignalR: (state: RootState) => state.initializingSignalR,

  historyOrder: (state: RootState) => state.historyOrder,

  userCurrentHistoryDate: (state: RootState) => state.userCurrentHistoryDate,

  openInBrowser: (state: RootState) => state.openInBrowser,

  preOrderCountForDate: (state: RootState) => state.preOrderCountForDate,

  acceptPreOrder: (state: RootState) => state.acceptPreOrder,
}

export default getters
